import { ErrorHandler, NgModule } from "@angular/core"
import { BrowserModule } from "@angular/platform-browser"
import { SplashScreen } from "@ionic-native/splash-screen"
import { StatusBar } from "@ionic-native/status-bar"
import { IonicStorageModule } from "@ionic/storage"
import { TranslateModule, TranslateLoader } from '@ngx-translate/core'
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { IonicApp, IonicErrorHandler, IonicModule } from "ionic-angular"
import { MusicService } from "../service/music.service"
import { RhythmService } from "../service/rhythm.service"
import { SoundService } from "../service/sound.service"
import { StatisticsService } from "../service/statistics.service"
import { WebAudioService } from "../service/webaudio.service"
import { GuiService } from "../utils/service/gui.service"
import { MyApp } from "./app.component"
import { Http } from "@angular/http"
import { HttpClient } from "@angular/common/http"
import { HttpClientModule } from "@angular/common/http"

export const version = "0.4.0"
const dbName = "SharpEars"

@NgModule({
	declarations: [
		MyApp
	],
	imports: [
		BrowserModule,
		IonicModule.forRoot(MyApp),
		IonicStorageModule.forRoot({name: dbName}),
		HttpClientModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: (createTranslateLoader),
				deps: [HttpClient]
			}
		})
	],
	bootstrap: [IonicApp],
	entryComponents: [
		MyApp
	],
	providers: [
		StatusBar,
		SplashScreen,
		{provide: ErrorHandler, useClass: IonicErrorHandler},
		GuiService,
		MusicService,
		RhythmService,
    SoundService,
		StatisticsService,
		WebAudioService
	]
})
export class AppModule {
}

export function createTranslateLoader(http: HttpClient) {
	return new TranslateHttpLoader(http, './assets/lang/', '.json')
}


// WEBPACK FOOTER //
// ./src/app/app.module.ts